import React from 'react';
import { Row, Col, Button, Alert, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Translate, translate, getUrlParameter, Storage } from 'react-jhipster';
import { connect } from 'react-redux';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { IRootState } from 'app/shared/reducers';
import { handleResetPassword, reset } from '../user.reducer';
import { SUCCESS, ERROR } from 'app/config/constants';
//import MessageModal from 'app/shared/message/message-modal';

export interface IPasswordResetModalProps extends StateProps, DispatchProps {
  modalShow: boolean;
  handleClose: Function;
}

export interface IPasswordResetModalState {
  visible: boolean;
  color: string;
  message: string;
  //showMessage: boolean;
}
export class PasswordResetModal extends React.Component<IPasswordResetModalProps, IPasswordResetModalState> {
  state: IPasswordResetModalState = {
    visible: false,
    color: 'danger',
    message: ''
    //showMessage: false
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.response !== nextProps.response) {
      const { response } = nextProps;
      if (response && response.status === SUCCESS) {
        this.setState({
          visible: true,
          color: 'success',
          message: translate('password.messages.success')
        });
        let timerId = setTimeout(() => {
          this.closeModal();
        }, 3000);
      } else if (response && response.status) {
        this.setState({
          visible: true,
          color: 'danger',
          message: response.message && response.message !== 'ERROR' ? response.message : translate('password.messages.error')
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  handleValidSubmit = (event, values) => {
    let password = values.newPassword;
    if (password && password.indexOf(' ') > -1) {
      this.setState({
        visible: true,
        color: 'danger',
        message: 'Mật khẩu không được chứa khoảng trắng.'
      });
    } else {
      this.props.handleResetPassword(values.currentPassword, values.newPassword);
    }
    event.preventDefault();
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  closeModal = () => {
    this.setState({ visible: false });
    this.props.handleClose();
  };

  render() {
    return (
      <div>
        {/* <MessageModal showModal={this.state.showMessage} message={'Chúc mừng bạn đã đổi mật khẩu thành công.'} /> */}
        <Modal
          className="hide-border-bottom-modal"
          isOpen={this.props.modalShow}
          toggle={this.closeModal}
          backdrop="static"
          centered={window.location === window.parent.location}
        >
          <ModalHeader toggle={this.closeModal} />
          <ModalBody className="padding-modal-body">
            <Row className="justify-content-center bodyModal">
              <Col md="12">
                <h2 className="text-center font-weight-bold" id="register-title">
                  <Translate contentKey="password.title">Registration</Translate>
                </h2>
                <h5 className="text-center txtContent">
                  <Translate contentKey="password.txtContent" />
                </h5>
                <p style={{ marginTop: '10px', textAlign: 'center' }}>
                  Tài khoản: <strong>{this.props.userProfile.fullname}</strong>{' '}
                </p>
                <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
                  {this.state.message}
                </Alert>
                <AvForm id="password-form" style={{ marginTop: '7%', marginBottom: '5%' }} onValidSubmit={this.handleValidSubmit}>
                  <AvField
                    name="currentPassword"
                    label={translate('global.form.currentpassword.label')}
                    placeholder={translate('global.form.currentpassword.placeholder')}
                    type="password"
                    validate={{
                      required: { value: true, errorMessage: translate('global.messages.validate.newpassword.required') }
                    }}
                  />
                  <AvField
                    name="newPassword"
                    label={translate('global.form.newpassword.label')}
                    placeholder={translate('global.form.newpassword.placeholder')}
                    type="password"
                    validate={{
                      required: { value: true, errorMessage: translate('global.messages.validate.newpassword.required') },
                      minLength: { value: 8, errorMessage: translate('global.messages.validate.newpassword.minlength') },
                      maxLength: { value: 30, errorMessage: translate('global.messages.validate.newpassword.maxlength') },
                      pattern: {
                        value: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,}$',
                        errorMessage: translate('global.messages.validate.newpassword.strengthmessage')
                      }
                    }}
                  />
                  <AvField
                    name="confirmPassword"
                    label={translate('global.form.confirmpassword.label')}
                    placeholder={translate('global.form.confirmpassword.placeholder')}
                    type="password"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: translate('global.messages.validate.confirmpassword.required')
                      },
                      minLength: { value: 8, errorMessage: translate('global.messages.validate.confirmpassword.minlength') },
                      maxLength: { value: 30, errorMessage: translate('global.messages.validate.confirmpassword.maxlength') },
                      match: {
                        value: 'newPassword',
                        errorMessage: translate('global.messages.error.dontmatch')
                      }
                    }}
                  />
                  <Button className="btn-register" type="submit" block>
                    <Translate contentKey="password.form.btnSave">Register</Translate>
                  </Button>
                </AvForm>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  response: storeState.userInfo.resResetPass,
  userProfile: storeState.userInfo.userProfile
});
const mapDispatchToProps = { handleResetPassword, reset };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordResetModal);
